module.exports = __webpack_public_path__ + "assets/img/2081591928118_.pic_hd.038b51d1.jpg";